module.exports = __webpack_public_path__ + "media/images/refund_money-efa28301a9b87b727063617c1c4eaadf.png";